// extracted by mini-css-extract-plugin
export default {"content-container":"NSI_content-container__0RnLw","main-text":"NSI_main-text__OaLq9","link":"NSI_link__bK-42"};